import { cx } from "@linaria/core";
import { FC, memo, useEffect, useRef, useState } from "react";
import { TypographyVariantsType } from "@/styles/utils/vars";
import { Button } from "@/ui/Button/Button";
import { cssButtonClean } from "@/ui/Button/StyledButton";
import { Typography } from "@/ui/Typography/Typography";
import { cssDescHidden, DescProduct, DescProductContainer, DescProductInner } from "./StyledDetail";
import { cssButtonIsActive } from "../../Paginator/StyledPaginator";
type DescriptionPropsType = {
  description: string;
  TypographyVariant?: TypographyVariantsType;
  heightPreview?: "xs" | "s" | "m" | "l" | "xl" | "xxl" | "xxxl";
};
const DESCRIPTION_LENGTH_LONG = 255;
const HEIGHT_PREVIEW = {
  xs: "50px",
  s: "75px",
  m: "100px",
  l: "125px",
  xl: "150px",
  xxl: "175px",
  xxxl: "200px"
};
export const DescriptionProduct: FC<DescriptionPropsType> = memo(({
  description,
  TypographyVariant = "p14",
  heightPreview = "xl"
}) => {
  const descriptionLength: number = description.length;
  const [descIsHidden, setDescIsHidden] = useState(true);
  const [descIsLong, setDescIsLong] = useState(descriptionLength > DESCRIPTION_LENGTH_LONG);
  const descTextRef = useRef<HTMLHeadingElement | null>(null);
  useEffect(() => {
    setDescIsLong(descriptionLength > DESCRIPTION_LENGTH_LONG);
  }, [descriptionLength]);
  if (!descriptionLength) {
    return null;
  }
  const height = descIsLong ? descIsHidden ? HEIGHT_PREVIEW[heightPreview] : `${descTextRef.current?.offsetHeight || 0}px` : undefined;
  return <DescProductContainer className={cx(descIsLong && descIsHidden && cssDescHidden)}>
        <DescProduct style={{
      height: height
    }}>
          <DescProductInner ref={descTextRef}>
            <Typography variant={TypographyVariant}>{description}</Typography>
          </DescProductInner>
        </DescProduct>
        {descIsLong && <>
            <Button variant={"link"} icon={"AngleBottom"} size={"small"} onClick={() => {
        if (descIsHidden) {
          setDescIsHidden(false);
        } else {
          setDescIsHidden(true);
        }
      }} className={cx(cssButtonClean, !descIsHidden && cssButtonIsActive)}>
              {descIsHidden ? "Подробнее" : "Свернуть"}
            </Button>
          </>}
      </DescProductContainer>;
});
DescriptionProduct.displayName = "DescriptionProduct";